export default (element) => new FormData(element);
